// Model visibility policy shared across backend (catalog/provider) and frontend.
//
// Models whose id contains any of these fragments are hidden from the model
// list and never picked as a default. This removes promotional/free models
// (Big Pickle, gpt-5-nano, grok-code) so new sessions fall back to the first
// real model returned by the catalog API, or to the user's configured model.
//
// Add fragments here to hide additional models from every surface at once.
export const HIDDEN_MODEL_ID_FRAGMENTS = ["big-pickle", "gpt-5-nano", "grok-code"]

export function isHiddenModel(id: string): boolean
export function isHiddenModel(model: { id: string }): boolean
export function isHiddenModel(input: string | { id: string }): boolean {
  const id = typeof input === "string" ? input : input.id
  return HIDDEN_MODEL_ID_FRAGMENTS.some((fragment) => id.includes(fragment))
}
